  地址输入框，包含国家，省，市，街道等分段输入框

<template>
  <el-form-item :label="title" :id="field.FIELD_ID" :ref="field.FIELD_ID" :class="itemClass"  v-if="isShow"
    :prop="field.FIELD_ID" :rules="rules">
    <div class="address"  :class="tailClass">
      <country-selector class="country" v-if="showCountry" v-model="country" :disabled="isDisabled" placeholder="国家">
      </country-selector>
      <!-- <el-cascader
        class="region"
        v-if="showRegion"
        size="large"
        :disabled="isDisabled"
        :options="addressOptions"
        :change-on-select="true"
        v-model="region"
        placeholder="请选择省市区"
      ></el-cascader>-->
      <region-selector class="region" v-if="showRegion" :disabled="isDisabled" :options="addressOptions"
        v-model="region" @update="updateRegion" placeholder="请选择省市区地址"></region-selector>
      <el-input class="street" v-model="street" :disabled="isDisabled" :placeholder="field.PLACE_HOLDER ||'请输入详细地址'"></el-input>
      <el-button class="use-id-address" v-if="isShowUseIDAddress" :disabled="isDisabled" @click="useIDAddress">
        {{field.useIDtext || "使用证件地址"}}</el-button>
    </div>
  </el-form-item>
</template>

<script>
import countrySelector from "../common/countrySelector";
import gxRegionData from "./citySelectData/cityselect-data";
// import RegionData from './citySelectData/zt-cityselect-data'
import { parseAddress } from "../../tools/util";
import validateRules from "./validateRules";
import regionSelector from "../common/regionSelector";

export default {
  data () {
    return {
      itemClass: "self-addressInput",
      isDisabled: false,
      country: "中国",
      region: [],
      street: "",
      qsName: "",
      // regionData: regionData,
      // addressOptions: regionData[this.qsName],
      addressOptions: [],
      triggerType: ["change", "blur"],
      rules: [],
      tailClass: "",
    };
  },
  props: ["field", "index", "groupId", "isBaseUI"],
  created () {
    this.qsName = this.$bizcfg.getBizConfigName(
      this.$definecfg.QSJGDM_CONST[this.$basecfg.qsVersion]
    );
    this.addressOptions = /*this.qsName == "ZHONGTAI" ? RegionData : */ gxRegionData;
    this.rules.push({
      validator: this.validatorField,
      trigger: this.triggerType,
    });
  },
  mounted () {
    this.itemClass += " " + this.field.FIELD_ID;

    if (this.isRequired) this.itemClass += " self-addressInput-required";

    if (this.isShowChange) this.itemClass += " self-addressInput-changed";

    if (this.isShowUseIDAddress)
      this.itemClass += " self-addressInput-use-ID-address";

    this.buildAddress(true);
  },
  components: {
    countrySelector,
    regionSelector,
  },
  computed: {
    title: function () {
      return _.trim(this.field.FIELD_TITLE)
        ? this.field.FIELD_TITLE +
        (_.intersection(this.field.FIELD_TITLE.split(""), ["：", ":"])
          .length
          ? ""
          : "：")
        : "";
    },
    isRequired: function () {
      return parseInt(this.field.FIELD_REQUIRED) ? true : false;
    },
    showCountry: function () {
      return this.field.showCountrySelector;
    },
    showRegion: function () {
      return this.field.showRegionSelector;
    },
    isShow: function () {
      let fieldControl = parseInt(this.field.FIELD_CONTROL);
      if (fieldControl == 2) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }

      if (fieldControl === 0 || fieldControl === 2) {
        return true;
      } else {
        return false;
      }
    },
    isShowUseIDAddress: function () {
      return this.field.FIELD_FUNCTION.indexOf("USE_ID_ADDRESS") != -1;
    },
    dataChange: function () {
      return this.field.DEFAULT_VALUE;
    },
    isShowChange: function () {
      return this.field.showchange;
    },
    //实际省市区 过滤不详
    realRegion: function () {
      if (this.region) {
        return this.region.filter((v) => v != "不详");
      }
      return [];
    },
  },
  methods: {
    buildAddress (notClear) {
      if (this.field.DEFAULT_VALUE) {
        let arr = parseAddress(this.field.DEFAULT_VALUE, this.qsName);
        this.field.addressInfo = arr;
        this.country = arr[0] ? arr[0] : "中国";
        if (this.showRegion) {
          this.region = arr[1];
          this.street = arr[2];
        } else {
          this.region = [];
          this.street = arr[2];
        }
      } else if (!notClear) {
        //edit liujiachen 如果default_value为空得时候这里没有清空原来得地址 添加分支清空原来的地址数据
        // this.country = '';
        this.region = [];
        this.street = "";
      }
    },
    validatorField: function (rule, value, callback) {
      let validate = {}, // 缓存报错的validate_rule;
        vParam = []; // 缓存validate_type 的传参
      value = this.field.DEFAULT_VALUE;

      // 过滤不显示的字段
      if (!this.isShow) {
        return false;
      }
      // 必填 数据为空，或非必填，选择了不完整的省市区
      if (
        (this.region.length < 3 && this.isRequired) ||
        (this.region.length > 0 && this.region.length < 3) ||
        (this.region.length < 3 && this.street !== "")
      ) {
        this.showErrorMsg = "请选择完整的省市区信息";
        this.field.correct = false;
        this.field.showerr = true;
        this.field.FIELD_CONTROL = "0";
        return callback(new Error(this.showErrorMsg));
      }
      // 必填，或已经选择了省市区的时候  详细地址非空判断
      else if (
        (this.region.length > 0 && this.street === "") ||
        (this.street === "" && this.isRequired)
      ) {
        this.showErrorMsg = "请填写详细地址";
        this.field.correct = false;
        this.field.showerr = true;
        this.field.FIELD_CONTROL = "0";
        return callback(new Error(this.showErrorMsg));
      } else {
        let isError = false;
        let validate_types = this.field.VALID_TYPE.split("|");

        if (value !== "" && validate_types[0] !== "") {
          isError = !validate_types.every((item) => {
            let v_type = item.replace(/\[.*\]/, ""),
              v_params = item.match(/\d+/g);

            validate = validateRules[v_type];
            vParam = v_params;
            if (!validate) {//如果没有对应规则，默认为通过
              return true;
            }
            return validate.valid(value, v_params);
          });
        }

        if (isError) {
          let message = validate.msg;
          if (vParam) {
            message = message
              .replace(new RegExp("\\{0\\}", "g"), vParam[0])
              .replace(new RegExp("\\{1\\}", "g"), vParam[1]);
          }
          this.showErrorMsg = message;
          this.field.correct = false;
          this.field.showerr = true;
          return callback(new Error(this.showErrorMsg));
        } else {
          this.field.correct = true;
          this.showErrorMsg = "";
          this.field.message = "";
          this.field.showerr = false;
          if (this.isBaseUI) {
            this.$emit("field-change", this.field);
          } else {
            this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, {
              field_id: this.field.FIELD_ID,
              module_id: this.field.MODULE_ID,
              index: this.index,
            });
          }
          return callback();
        }
      }
    },
    //使用证件地址 按钮
    useIDAddress: function () {
      if (this.isBaseUI) {
        this.$emit("use-id-address", this.field);
      } else {
        //更改state的值，触发全局的字段赋值事件
        let data = {};
        data["FIELD_ID"] = this.field.FIELD_ID;
        data["GROUP_ID"] = this.groupId;
        data["MODULE_ID"] = this.field.MODULE_ID;
        data["index"] = "0";
        this.$store.commit(this.$types.UPDATE_COMPONENT_BUTTON_CLICK, data);
      }
    },
    // 更新选择区域
    updateRegion (value) {
      this.region = value;
      let data = {};
      data["FIELD_ID"] = this.field.FIELD_ID;
      data["GROUP_ID"] = this.groupId;
      data["MODULE_ID"] = this.field.MODULE_ID;
      data["index"] = "0";
      data["type"] = "regionSelect";
      this.$store.commit(this.$types.UPDATE_COMPONENT_BUTTON_CLICK, data);
    },
 
  },
  watch: {
    isRequired: function (val) {
      if (val) {
        this.itemClass += " self-addressInput-required";
      } else {
        this.itemClass = this.itemClass.replace(
          /self-addressInput-required/g,
          ""
        );
      }
    },
    isShowChange: function (val) {
      if (val) {
        this.itemClass += " self-addressInput-changed";
      } else {
        this.itemClass = this.itemClass.replace(
          /self-addressInput-changed/g,
          ""
        );
      }
    },
    showRegion: function (val) {
      this.buildAddress();
    },
    showCountry: function (val) {
      this.buildAddress();
    },
    country: function (val) {
      if (["中国", "中国台湾", "香港", "澳门"].indexOf(val) != -1) {
        this.field["showRegionSelector"] = true;
      } else {
        this.field["showRegionSelector"] = false;
      }

      this.field.DEFAULT_VALUE = val + this.realRegion.join("") + this.street;
    },
    region: function (val) {
      //地址选择栏变动时手动调用一下校验
      this.$refs[this.field.FIELD_ID] &&
        this.$refs[this.field.FIELD_ID].validate("blur");
      if (this.showCountry) {
        this.field.DEFAULT_VALUE =
          this.country + this.realRegion.join("") + this.street;
      } else {
        this.field.DEFAULT_VALUE = this.realRegion.join("") + this.street;
      }
    },
    street: function (val) {
      if (this.showCountry) {
        this.field.DEFAULT_VALUE =
          this.country + this.realRegion.join("") + val;
      } else {
        this.field.DEFAULT_VALUE = this.realRegion.join("") + val;
      }
    },
    dataChange: {
      handler (newVal, oldVal) {
        //ocr识别回填字段时，会监听到，但是不需要去除ocr标识
        if(oldVal){
          //如果输入框中的值发生变化，ocr标识消失
          this.field.DATA_SOURCE = 0;
        }
        // this.field.message = "";
        this.buildAddress();
      },
      immediate: true
    },
    "field.DATA_SOURCE": {
      handler (val, oldVal) {
        this.tailClass = this.tailClass.replace("ocrIcon","");
        this.tailClass = this.tailClass.replace("zzIcon","");
        this.tailClass = this.tailClass.replace("zdIcon","");
        if (val == "1") {
          this.tailClass += " ocrIcon";
        } else if (val == "2") {
          this.tailClass += " zzIcon";
        } else if (val == "3") {
          this.tailClass += " zdIcon";
        }
      },
      immediate: true
    }
  },
};
</script>

<style lang="less">
@import "./countryselector.css";
.self-addressInput {
  width: 95% !important;
  display: flex;
  .el-form-item__label {
    font-size: 20px;
    min-width: 170px;
    text-align: right;
  }
  .el-form-item__content {
    font-size: 20px;
    color: #000;
    flex: 1;
    position: relative;

    .address {
      display: inline-flex;
      width: 66%;
      position: relative;
      .country {
        display: inline-flex;
        flex: 1;
        input {
          height: 40px;
          line-height: 40px;
          font-size: 20px;
        }
      }
      .region {
        display: inline-flex;
        flex: 3;
        font-size: 20px;
        .el-cascader__label {
          line-height: 66px;
        }
      }
      .street {
        display: inline-flex;
        flex: 3;
        width: 55%;
      }
      .el-button {
        background: #f9f9f9;
        flex: 0 0 80px;
        display: inline-flex;
        width: 120px;
      }
    }
    /**这三个伪元素，是组件独有的，不影响公共的
     */
    .ocrIcon::after {
      content: "";
        display: inline-block;
        background-image: url(../../../static/assets/img/newCode/dataSourceIcon/OCR_ICON.png);
        background-size:cover;
        width: 40px;
        height: 20px;
        position: absolute;
        right: -50px;
        top: 10px;
    }
    .zzIcon::after {
      content: "";
        display: inline-block;
        background-image: url(../../../static/assets/img/newCode/dataSourceIcon/ZHONGZHENG.png);
        background-size:cover;
        width: 40px;
        height: 20px;
        position: absolute;
        right: -50px;
        top: 10px;
    }
    .zdIcon::after {
      content: "";
        display: inline-block;
        background-image: url(../../../static/assets/img/newCode/dataSourceIcon/ZHONGDENG.png);
        background-size:cover;
        width: 40px;
        height: 20px;
        position: absolute;
        right: -50px;
        top: 10px;
    }
  }
}

.self-addressInput-required {
  .el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}

// .self-addressInput-changed {
//   input.el-input__inner,
//   .k-country input {
//     // background: rgba(252, 230, 56, 0.2) !important;
//   }
// }

.self-addressInput-use-ID-address {
  .street .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .el-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left-width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preEntry/addressInputItem.vue